/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProductApprovalDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    readonly approvalId?: number;
    productFormulation?: string;
    sheet?: string;
    cost: string;
    readonly sheetNumber?: string;
    readonly formulation?: string;
    readonly amount?: number;
    orderNumber?: string;
    remark?: string;
    processTypeIdentifier: ProductApprovalDto.processTypeIdentifier;
    productApprovalState: ProductApprovalDto.productApprovalState;
    readonly actionRequired?: boolean;
    readonly rejectionViewedAt?: string;
};
export namespace ProductApprovalDto {
    export enum processTypeIdentifier {
        INITIAL_APPROVAL = 'INITIAL_APPROVAL',
        RENEWAL = 'RENEWAL',
        RENEWAL_APPROVAL = 'RENEWAL_APPROVAL',
        CHANGE_APPROVAL = 'CHANGE_APPROVAL',
        ADDITIONAL_FORMULATIONS = 'ADDITIONAL_FORMULATIONS',
        ADDITIONAL_SHEET = 'ADDITIONAL_SHEET',
        FORMULATION_CHANGE = 'FORMULATION_CHANGE',
        LEGACY_MIGRATION = 'LEGACY_MIGRATION',
    }
    export enum productApprovalState {
        PENDING = 'PENDING',
        CANCELLED = 'CANCELLED',
        REJECTED = 'REJECTED',
        INVOICE_OPEN = 'INVOICE_OPEN',
        CERTIFICATE_IN_COMPLETION = 'CERTIFICATE_IN_COMPLETION',
        APPROVED = 'APPROVED',
    }
}

